<template>
  <div>
    <v-alert v-if="errors.non_field_errors" dense border="left" type="error">
      We can't log you in to the site:
      <span v-for="(error, key) in errors.non_field_errors" :key="key">
        {{ error }}
      </span>
    </v-alert>
    <v-form @submit.prevent="submit">
      <v-card width="400" class="mx-auto my-8">
        <v-card-title><span class="headline">Who are you?</span></v-card-title>
        <v-card-text>
          <v-text-field
            required
            name="username"
            label="Email"
            type="email"
            v-model="email"
            prepend-icon="mdi-account-circle"
            :error="errors.email !== undefined"
            :error-messages="errors.email"
          />
          <v-text-field
            required
            name="password"
            label="Password"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :error="errors.password !== undefined"
            :error-messages="errors.password"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <RegisterPopup @registered="registerSuccessful" />
          <v-btn type="submit" outlined color="success" class="mx-auto">
            <span>Log in</span>
            <v-icon right>mdi-login-variant</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <p class="text-center">
        <router-link :to="{ name: 'password-reset' }"
          >Forgot my password</router-link
        >
      </p>
    </v-form>

    <v-snackbar v-model="snackbar" top>
      We've sent you an e-mail to validate your account.
      <v-btn color="success" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RegisterPopup from "@/components/RegisterPopup.vue";

export default {
  name: "LoginForm",
  components: { RegisterPopup },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      snackbar: false,
      errors: {}
    };
  },
  methods: {
    ...mapActions("accounts", ["login"]),
    ...mapGetters("routing", ["nextRoute"]),
    async submit() {
      try {
        this.errors = {};

        await this.login({
          email: this.email,
          password: this.password
        });
        this.$emit("loggedIn");
        this.$router.push(this.nextRoute());
      } catch (e) {
        this.errors = e.response.data;
      }
    },
    registerSuccessful() {
      this.snackbar = true;
    }
  }
};
</script>
